// extracted by mini-css-extract-plugin
export default {"root":"zLg0r_","wired":"tQG0KT","hasImage":"u_Ali1","actions":"BfTAJm","mobile":"scPnnC","image":"zGwMGa"};